import api from '@/shared/api';

export type DocumentLinkContainerType = 'folder' | 'module';

export interface DocumentLinkContainer {
  type: DocumentLinkContainerType;
  id: number;
}

interface LinkDocumentsToContainerResponse {
  linkedCount: number;
}

function buildDocumentsUrl(container: DocumentLinkContainer): string {
  return container.type === 'module'
    ? `/modules/${container.id}/documents`
    : `/folders/${container.id}/documents`;
}

/**
 * Vincula REVISÕES ao container. A unidade do vínculo é a revisão: enviar `documentId` faria a
 * pasta receber o documento, e o backend escolheria por conta própria qual revisão exibir.
 */
export async function linkDocumentRevisionsToContainer(
  container: DocumentLinkContainer,
  documentRevisionIds: number[]
): Promise<number> {
  const response = await api.post<{ data: LinkDocumentsToContainerResponse }>(
    buildDocumentsUrl(container),
    { documentRevisionIds }
  );

  return response.data.data.linkedCount;
}
